<template>
<div class="newItem " @click="tapMe(item)"   @mouseover="Tapmouseover"  @mouseleave="mouseoutMe">
    <div class="n-item ">
         <div class="roll" :style="{width:width,height: height}"  >
            <img :src="getImgUrlP(item.litpic)" :style="{width:width,height: height}" class="biger"  />           
         </div>
         <div class="atext" :style="{width:width}">
           <div class="date" v-if="type=='home'" >
             <img :src="getImgUrl1(item.addTime.substr(8,2))"  style="width: 89px;height: 50px;" v-if="isJumps =='0'" />
             <span class="f16" style="color:#ccc" v-if="isJumps =='0'"> / {{item.addTime.substr(5,2)}}</span>

              <img :src="getImgUrl2(item.addTime.substr(8,2))"  style="width: 89px;height: 50px;" v-if="isJumps =='1'" />
             <span class="f16" style="color:#dce3ee" v-if="isJumps =='1'"> / {{item.addTime.substr(5,2)}}</span>

           </div>
           <div class="f18 c3" style="text-align:left"><strong>{{item.title}}</strong></div>
           <div class="f16 c6 ln28" :style="{height:lnheight}">{{item.subtitle}}</div>
         </div>
    </div>
</div>
</template>
<script>
export default {
    props:['type','width','height','lnheight','item','lmid']   ,
    data(){
            return{
                len:13,isJumps:'0'
            }
    },
    // computed: {
  
    // },
    methods: {
          Tapmouseover(){         
              this.isJumps = '1'
          },
          mouseoutMe(item){
              this.isJumps ='0' 
          },
          getImgUrl1 (date) {
            return require("../assets/images/1/home_date_" + date+ ".png");
          },
           getImgUrl2 (date) {
            return require("../assets/images/1/xwlb_date_" + date+ ".png");
          },
          getImgUrlP (src) {
            // var src = "http://pc.shihua.com/prod-api/"+ src
             return src
          },
          tapMe(item){     
            if(this.lmid!='74')     {
               this.$router.push({path: '/News/detail?id='+item.aid+'&&lmid='+this.lmid })  
            }  
            
          }
    }
}
</script>
<style scoped>
.newItem {
  background: #fcfeff;
  margin-right:20px;
  cursor:pointer
}
.newItem:last-child {
  margin:0
}
.newItem .atext{
  padding-bottom:26px
}
.newItem .atext .f18{
  margin: 15px 0 10px 0;
  height:28px;
  line-height: 28px; 
  text-overflow: ellipsis;
  white-space: nowrap; 
  padding:0 20px;
  overflow: hidden;
}
.newItem .atext .date{
  margin: 30px 20px;
}
.newItem .atext .ln28{
   overflow:hidden;
   padding:0 20px
}
.n-item:hover{
   background: #2A579E;
   box-shadow: 0px 1px 20px 0px rgba(15,81,117,0.20); 
}
.n-item:hover .f18,.n-item:hover .f16{
   color:#fff
}
.n-item .biger{
  transition: all 0.6s;
}
.n-item:hover  .biger{
   transform: scale(1.2);
}
.n-item .roll{
  overflow: hidden;
  display:block
}
</style>



// WEBPACK FOOTER //
// src/components/NewItem.vue